import { inject, Service } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs";

import { AdaaHelper, isDsV2 } from "../../core/utils";
import { Constants } from "../../shared/constants/constants";
import { AdaaBoolean } from "../../shared/constants/enums";
import { ObjectivesApiService } from "../../shared/services";

@Service()
export class SearchProvider {
  private readonly _router = inject(Router);
  private readonly _objectivesApiService = inject(ObjectivesApiService);

  public objectivesRedirection(id: number, entityId: number) {
    if (!isDsV2() && AdaaHelper.isPMOEntity(entityId)) {
      return this._router.navigate(["/console", "objectives", id]);
    }
    return this._objectivesApiService
      .getEnablerCardById(id)
      .pipe(map(({ responseData }) => responseData))
      .subscribe({
        next: (res) => {
          if (res.enabler === AdaaBoolean.Y && res.objectiveType === Constants.OBJECTIVE_TYPE.ENABLER_OBJECTIVE) {
            this._router.navigate(["/console", "pmo-objectives", "enabler-objective", res.id]);
          } else if (res.objectiveType === Constants.OBJECTIVE_TYPE.MAIN_OBJECTIVE) {
            this._router.navigate(["/console", "objectives", "main-objective", res.id]);
          } else if (res.objectiveType === Constants.OBJECTIVE_TYPE.STRATEGIC_OBJECTIVE) {
            this._router.navigate(["/console", "objectives", "strategic-objective", res.id]);
          } else if (res.objectiveType === Constants.OBJECTIVE_TYPE.TRANSFORMATIONAL_OBJECTIVE) {
            this._router.navigate(["/console", "pmo-objectives", "transformational-objective", res.id]);
          }
        },
      });
  }
}
